import { CoreMap } from '../../core';
import type { SchoolSoftFileTypes } from '../../SchoolSoft';
import { SchoolSoftMap } from '../../SchoolSoft';
import { PlanDigitalMap } from '../../PlanDigital';
import { AdmentumMap } from '../../Admentum';
import { IdunSoftMap } from '../../IdunSoft';
import { Skola24Map } from '../../Skola24';
import { RSMap } from '../../RS';
import { ExcelMap } from '../../Excel';
import { structure as RSstructure } from '../../RS/types/to';


const core_structure = {
  groups:    ['id'],
  locations: ['id'],
  teachers:  ['id'],
  courses:   ['id', 'events', 'groups', 'subject', 'teachers'],
};

const excel_structure = {
  meta:      [['structure']],
  courses:   [],
  groups:    [],
  locations: [],
};

const RS_structure = {
  events: ['output', 'coreData'],
};

const Admentum_structure = {
  schools:                  ['url', 'id', 'unit_code', 'school_code', 'school_type', 'name'],
  schedule:                 ['url', 'id', 'school_id', 'school_year', 'start_date', 'end_date', 'start_time', 'end_time', 'is_active', 'archived_at'],
  rooms:                    ['url', 'id', 'school_id', 'name', 'category', 'capacity'],
  teachers:                 ['url', 'id', 'school_id', 'email', 'first_name', 'last_name', 'role', 'current_primary_group', 'account_id'],
  principals:               ['url', 'id', 'school_id', 'email', 'first_name', 'last_name', 'role', 'current_primary_group', 'account_id'],
  courses:                  ['url', 'id', 'school_id', 'schedule_id', 'name', 'subject_code', 'start_date', 'end_date', 'teachers', 'gymnasium_course'],
  schedule_groups:          ['url', 'id', 'eid', 'school_id', 'schedule', 'name', 'guid', 'teachers', 'users_primary_groups', 'subjects', 'courses'],
  primary_groups:           ['url', 'id', 'eid', 'school_id', 'schedule', 'grade', 'name', 'guid', 'teachers', 'start_date', 'end_date', 'start_date_display', 'end_date_display'],
  schedule_events:          ['url', 'id', 'eid', 'school_id', 'schedule_id', 'start_time', 'end_time', 'rooms', 'teachers', 'schedule_groups', 'primary_groups', 'weekly_interval'],
  schedule_event_instances: ['url', 'id', 'school_id', 'start_date', 'end_date', 'schedule_event'],
  lessons:                  ['url', 'id', 'school_id', 'date', 'info', 'teachers', 'room', 'weekday'],
  lesson_infos:             ['url', 'id', 'eid', 'school_id', 'schedule_id', 'start', 'end', 'duration', 'room', 'subject', 'teachers', 'groups', 'weekly_interval'],
};

const IdunSoft_structure = {
  Grupp:   ['ID', 'Klassnamn'],
  Lärare:  ['ID', 'Namn'],
  Rum:     ['ID', 'Namn'],
  Ämne:    ['Ämne', 'Betygskod'],
  Lektion: ['LektionID', 'Ämne', 'Starttid', 'Sluttid', 'Lektionslängd', 'LärareID', 'GruppID', 'RumID', 'VeckodagID']
};

const Skola24_txt_structure = null;

const Skola24_mdb_structure = {
  unit_tblroom:               [ 'PK', 'ID' ],
  school_tblsubject:          [ 'PK', 'ID' ],
  school_tblteacher:          [ 'PK', 'ID' ],
  school_tblgroup:            [ 'PK', 'ID', 'bClass' ],
  school_tblplan:             [ 'PK', 'FKSubject' ],
  school_tblcourse:           [ ],
  school_tblschedule:         [ 'PK', 'Length', 'StartTime', 'DayOfWeek', 'FKSubject', 'CalcActualWeeks' ],
  school_tblgroup_group:      [ 'FKGroup', 'FKGroupCon' ],
  school_tblplan_period:      [ 'FKPlan', 'FKPeriod' ],
  school_tblplan_teacher:     [ 'FKPlan', 'FKTeacher' ],
  school_tblplan_group:       [ 'FKPlan', 'FKGroup' ],
  unit_tblperiod_date:        [ 'FKPeriod', 'StartDate', 'EndDate' ],
  school_tblschedule_period:  [ 'FKSchedule', 'FKPeriod' ],
  school_tblschedule_teacher: [ 'FKSchedule', 'FKTeacher' ],
  school_tblschedule_group:   [ 'FKSchedule', 'FKGroup' ],
  school_tblschedule_room:    [ 'FKSchedule', 'FKRoom' ]
};

// this is only temporary
const PlanDigital_structure = {
  'Perioder':                 [ 'Namn', 'Tidsenhet' ],
  'Tabell Tjänstefördelning': [ 'Gruppnamn', 'Klass', 'Kurskod', 'Sign', 'Poäng', 'Anteckningar', 'Antal', 'Ämne', 'Kursnamn' ]
};

const SchoolSoft_structure: (keyof SchoolSoftFileTypes.event)[] = [
  'id',
  'group',
  'dayid',
  'day',
  'starttime',
  'length',
  'teacher',
  'subject',
  'room',
  'period',
  'inweek',
  'exweek',
  'exclass',
  'realweeks'
];

export const maps = [
  {
    structure: Skola24_txt_structure,
    matchType: 'string',
    name:      'Skola24 (txt)',
    map:       Skola24Map.TXT,
    meta:      { structure: '' }
  }, {
    structure: Admentum_structure,
    name:      'Admentum',
    map:       AdmentumMap,
    meta:      { structure: '' }
  }, {
    structure: SchoolSoft_structure,
    name:      'SchoolSoft',
    map:       SchoolSoftMap,
    meta:      { structure: '' }
  }, {
    structure: PlanDigital_structure,
    name:      'Plan Digital',
    map:       PlanDigitalMap,
    meta:      { structure: '' }
  }, {
    structure: IdunSoft_structure,
    name:      'IdunSoft',
    map:       IdunSoftMap,
    meta:      { structure: '' }
  }, {
    structure: Skola24_mdb_structure,
    name:      'Skola24 (mdb)',
    map:       Skola24Map.MDB,
    meta:      { structure: '' }
  }, {
    structure: RS_structure,
    name:      'Royal Schedule Algorithm',
    map:       RSMap,
    meta:      { structure: RSstructure }
  }, {
  //   structure: core_structure,
  //   name:      'Royal Schedule',
  //   map:       CoreMap.V1,
  //   meta:      { structure: 'RS/core-1.0.0' }
  // }, {
    structure: core_structure,
    name:      'Royal Schedule',
    map:       CoreMap,
    meta:      { structure: 'RS/core-2.0.0' }
  }, {
    structure: excel_structure,
    name:      'Royal Schedule Excel',
    map:       ExcelMap.V1,
    meta:      { structure: 'RS/Excel-1.0.0' }
  }, {
    structure: excel_structure,
    name:      'Royal Schedule Excel',
    map:       ExcelMap.V2,
    meta:      { structure: 'RS/Excel-2.0.0' }
  }
] as const;